import Swiper, { Navigation, Pagination, Autoplay, EffectFade, EffectCards, Thumbs } from 'swiper';
import Cookies from 'js-cookie';
import { handleCampaignSessionStorage, throttle } from './utils';
import PhotoSwipeLightbox from 'photoswipe/lightbox';
import { consentMode } from './consentmode/_consent-mode'
import noUiSlider from 'nouislider';

document.addEventListener('DOMContentLoaded', () => {
  handleCampaignSessionStorage();

  // mobile menu
  const masthead = document.querySelector('.masthead');
  document.querySelectorAll('.mobile-menu-toggle').forEach((el) => {
    el.addEventListener('click', (e) => {
      e.preventDefault();

      masthead.classList.toggle('toggled');
    });
  });

  // phone toggle
  document.querySelector('.masthead--nav-phone-toggle').addEventListener('click', (e) => {
    e.preventDefault();

    document.querySelector('.masthead--nav-phone-placeholder').innerHTML =
      '<a href="tel:+48 222 645 261">+48 222 645 261</a>';

    document.querySelector('.masthead--nav-phone-placeholder a').addEventListener('click', () => {
      // eslint-disable-next-line no-undef
      gtag('event', 'generate_lead', { event_category: 'telefon', event_label: 'klik' });
    });

    e.target.remove();
  });

  // scroll observer
  if (masthead) {
    masthead.classList.toggle('scrolled', window.scrollY > 100);
    window.addEventListener(
      'scroll',
      throttle(() => {
        masthead.classList.toggle('scrolled', window.scrollY > 100);
      }, 30)
    );
  }

  // nav links
  document.querySelectorAll('.masthead--nav a').forEach((el) => {
    el.addEventListener('click', (e) => {
      if (document.body.classList.contains('home') && el.hash) {
        e.preventDefault();

        masthead.classList.remove('toggled');

        document.querySelector(el.hash).scrollIntoView({
          behavior: 'smooth',
        });
      }
    });
  });

  // cookie notice
  document.querySelector('.cookie-notice--btn')?.addEventListener('click', (event) => {
    event.preventDefault();

    Cookies.set('cookies_accepted', 1);

    document.querySelector('.cookie-notice').remove();
  });

  // contact forms event
  document.querySelectorAll('.wpcf7').forEach((el) => {
    el.addEventListener(
      'wpcf7mailsent',
      function () {
        // eslint-disable-next-line
        gtag('event', 'generate_lead', { event_category: 'formularz', event_label: 'wyslij' });
      },
      false
    );
  });

  // contact forms floating labes
  document.querySelectorAll('.floating-label').forEach((el) => {
    const span = document.createElement('span');
    span.innerText = el.dataset.label;

    el.querySelector('.wpcf7-form-control-wrap').appendChild(span);
  });

  if (document.body.classList.contains('home')) {
    // hero slides bg loaded
    document.querySelectorAll('.home-hero .swiper-slide')?.forEach((slide) => {
      const slideBgImgSrc = slide.dataset.bgImg;
      const slideBgImg = new Image();

      slideBgImg.addEventListener('load', function () {
        slide.classList.add('bg-img-loaded');
        slide.style.backgroundImage = `url(${slideBgImgSrc})`;
      });

      slideBgImg.src = slideBgImgSrc;
    });

    // amenities slider
    new Swiper('.home-amenities--main-items-slider-wrapper', {
      modules: [Navigation],
      loop: true,
      centeredSlides: true,
      slidesPerView: 'auto',
      spaceBetween: 32,
      navigation: {
        prevEl: '.swiper-buttons-prev',
        nextEl: '.swiper-buttons-next',
      },
      breakpoints: {
        992: {
          spaceBetween: 32,
        },
      },
    });

    // galleries slider
    const sliders = document.querySelectorAll('.home-gallery--slider');

    document.querySelectorAll('.home-gallery--header button').forEach((button, i, array) => {
      button.addEventListener('click', (e) => {
        e.preventDefault();

        // set active class
        if (!button.classList.contains('active')) {
          array.forEach((el) => el.classList.remove('active'));
          button.classList.add('active');
        }

        if (!sliders[i].classList.contains('active')) {
          sliders.forEach((el) => el.classList.remove('active'));
          sliders[i].classList.add('active');
        }
      });
    });

    sliders.forEach((g) => {
      new Swiper(g, {
        modules: [Navigation],
        centeredSlides: true,
        loop: true,
        slidesPerView: 1.2,
        spaceBetween: 16,
        navigation: {
          prevEl: '.swiper-buttons-prev',
          nextEl: '.swiper-buttons-next',
        },
        breakpoints: {
          992: {
            slidesPerView: 1.5,
          },
          1200: {
            slidesPerView: 2,
          },
        },
      });

      const galleryLightbox = new PhotoSwipeLightbox({
        gallery: g,
        children: 'a',
        showAnimationDuration: 0,
        hideAnimationDuration: 0,
        pswpModule: () => import('photoswipe'),
      });

      galleryLightbox.init();
    });

    // calc
    const calcItems = document.querySelectorAll('.home-calc--item');
    document.querySelectorAll('.home-calc--header button').forEach((button, i, array) => {
      button.addEventListener('click', (e) => {
        e.preventDefault();

        // set active class
        if (!button.classList.contains('active')) {
          array.forEach((el) => el.classList.remove('active'));
          button.classList.add('active');
        }

        if (!calcItems[i].classList.contains('active')) {
          calcItems.forEach((el) => el.classList.remove('active'));
          calcItems[i].classList.add('active');
        }
      });
    });

    // process slider
    const processSlider = new Swiper('.home-process--stages-slider-wrapper', {
      modules: [Pagination],
      centeredSlides: true,
      slidesPerView: 1.5,
      spaceBetween: 32,
      breakpoints: {
        992: {
          slidesPerView: 2.5,
          spaceBetween: 32,
        },
        1200: {
          slidesPerView: 1,
          spaceBetween: 0,
          noSwiping: true,
          allowTouchMove: false,
        },
      },
    });

    document.querySelectorAll('.home-process g.point').forEach((point, i, array) => {
      point.addEventListener('click', (e) => {
        e.preventDefault();

        array.forEach((el) => el.classList.remove('active'));
        point.classList.add('active');

        processSlider.slideTo(i);
      });
    });



    // benefits slider
    var swiperText = new Swiper(".home-benefits-slider-wrapper-2", {
      slidesPerView: 1,
      freeMode: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
    });

    var swiperBenefits = new Swiper('.home-benefits-slider-wrapper', {
      modules: [Thumbs, Navigation, EffectCards],
      effect: "cards",
      grabCursor: true,
      navigation: {
        prevEl: '.home-benefits-slider-button-prev',
        nextEl: '.home-benefits-slider-button-next',
      },
      thumbs: {
        swiper: swiperText,
      }
    });

    let askOfferBtn = document.querySelector('[data-ask-offer]')

    askOfferBtn.addEventListener('click', (e) => {
      const element = document.querySelector('.home-contact--form')
      let headerHeight = 60

      window.scrollTo({
        'behavior': 'smooth', 'left': 0, 'top': element.offsetTop - headerHeight
      })
    })

  }


   /*new Swiper('.home-hero--slider', {
     modules: [Autoplay, EffectFade],
     effect: 'fade',
     autoplay: {
       delay: 4000,
     },
     speed: 600,
     loop: true,
    // spaceBetween: 32,
    // breakpoints: {
    //   992: {
    //     slidesPerView: 2.5,
    //     spaceBetween: 32,
    //   },
    //   1200: {
    //     slidesPerView: 1,
    //     spaceBetween: 0,
    //     noSwiping: true,
    //     allowTouchMove: false,
    //   },
    // },
  });*/

  consentMode()

});
